<template>
<task-order-data></task-order-data>
</template>
<script>
import taskOrderData from "cps/task-order/withData"
export default {
	components:{
		taskOrderData
	}
}
</script>